import type { ResolvedTheme } from '../../types/ThemeType';

import { getDesignThemeTokens } from './tokenRegistry';
import { toCssVariables } from './toCssVariables';

export const applyDesignTokens = (
  theme: ResolvedTheme,
  root: HTMLElement = document.documentElement
): void => {
  const variables = toCssVariables(getDesignThemeTokens(theme));

  Object.entries(variables).forEach(([name, value]) => {
    root.style.setProperty(name, value);
  });
};
